export const customLayerSourceType = "CustomLayerSourceType";
export const customLayerType = "CustomLayerType";
export const CUSTOM_LAYER_SOURCE = "Vind - Uploaded" as const;
